import { useMemo, memo } from 'react'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import InputLabel  from '@mui/material/InputLabel'
import FormHelperText from '@mui/material/FormHelperText'

function InputSelect({
    onChange,
    callback = false,
    label, 
    name, 
    id,
    placeholder,
    value,
    options,
    native,
    helperText,
    disableHelperText,
    errors, 
    touched, 
    disabledOption,
    ...others 
}) {
  
    
    const { helperValue, error } = useMemo( () => {
        
        const hasError  = errors !== undefined

        return {
           helperValue: hasError && touched[name] && Boolean(errors[name]) ? errors[name] : ' ',
           error      : hasError && touched[name] && Boolean(errors[name]) 
        }

    }, [name, errors, touched])

    const emptyOption = ( items ) => {
        return items?.length > 0 ? items : [{  
            value: '', 
            title: 'Nenhuma opção encontrada!',
            disabled: true
        }]
    }

    return (
        <>  
            <FormControl fullWidth error={error} >  
                <InputLabel component={'span'} id={`${name}-label`} htmlFor={`${name}-label`} >{label}</InputLabel>
                <Select
                    sx={ () => {
                        if (error) return { color: '#ff4d4f' }
                    }}

                    label={label}
                    labelId={`${name}-label`}
                
                    value={value}
                    onChange={onChange}
                    inputProps={{ id: `${name}-label` }}
                    name={name}
                    renderValue={(selected) => {
                        
                        if (selected?.length === 0) {
                            return <span style={{ 

                                fontFamily: "'Public Sans', sans-serif",
                                fontWeight: 400, 
                                color: '#8c8c8c' 
                            }}>{placeholder}</span>
                        }

                        if (Array.isArray(selected)) {
                            const optionsArray =  options?.filter((item) => selected.includes(item.value))
                            const titles       = optionsArray?.map( item => item.title)
                            return titles?.join(', ')
                            
                        }
            
                        return options?.find((item) => item.value === selected)?.title || ''
                    }}

                    {...others}
                    
                >

                    
                    
                    {  emptyOption(options).map( (opt, index) => { 
                        
                        if (native !== undefined) {
                            return <option 
                                disabled={(disabledOption && !opt?.value) || opt?.disabled} 
                                key={index} 
                                value={opt?.value || ''}
                            >{opt.title}</option>
                        }

                        return <MenuItem 
                            disabled={(disabledOption && !opt?.value) || opt?.disabled} 
                            key={index} 
                            value={opt?.value || ''}
                        >
                            {opt.title}
                        </MenuItem> })
                    }
        
                </Select>
                {!disableHelperText ? <FormHelperText children={helperValue} /> : ''}
            </FormControl>
        </>
    )
}

export default memo(InputSelect)